import React from "react";

import { Button } from "./button";
import { FlowpiAlertDialog } from "./flowpi-dialog";

export default function UnsavedChangesDialog({ open, onStay, onLeave }) {
  return (
    <FlowpiAlertDialog
      open={open}
      onClose={onStay}
      eyebrow="Unsaved Changes"
      title="Discard changes?"
      description="You have unsaved changes. If you leave now, your entered or modified data will be lost."
      closeLabel="Continue Editing"
      testId="unsaved-changes-dialog"
      footer={(
        <>
          <Button type="button" onClick={onStay} variant="neutral" data-action-category="cancel">
            Continue Editing
          </Button>
          <Button type="button" onClick={onLeave} variant="destructive" data-action-category="destructive">
            Discard Changes
          </Button>
        </>
      )}
    >
      You have unsaved changes. If you leave now, your entered or modified data will be lost.
    </FlowpiAlertDialog>
  );
}
